var _style, _path, _defs, _defs2, _g, _g2, _path2, _path3, _animateTransform, _animateTransform2, _animateTransform3, _animateTransform4, _animateTransform5, _animateTransform6, _animateTransform7, _animateTransform8, _animateTransform9, _animateTransform10, _animateTransform11, _animateTransform12, _animateTransform13, _animateTransform14, _animateTransform15, _animateTransform16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampfireTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1025.9 535.1",
    style: {
      enableBackground: "new 0 0 1025.9 535.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000044855964804771763110000007215583073693319341_);fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000131326073060517820910000008740798486614006918_);fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:#FBC445;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000047781653163800467470000013004895865985298330_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.8,163.9c0-41.8,33.6-75.9,75.5-75.9c25,0,48.4,12.3,62.5,33l-26.3,18.3c-7.8-11.9-19.2-19.2-34.7-19.2 c-25,0-42.9,19.2-42.9,43.8s17.3,44.4,42.7,44.4c15.8,0,27.2-7.3,34.9-19.4l26.3,18.5c-14.1,20.6-37.6,32.9-62.5,32.8 C71.4,240.2,37.8,206.2,37.8,163.9z M228,174.7l16.6-52l16.8,52H228z M282.1,238.5h36L263.4,89.9h-36.9l-55,148.6h36.2l11-34.5 H271L282.1,238.5z M502.4,238.5L484.3,89.9h-28.9l-42.7,92.9l-43.4-92.9H341l-18.3,148.6h34.7l9.9-84.3l32.4,67.3h25.9L458,154 l9.7,84.5H502.4z M567.3,158.5h-25.9v-39h26.1c12.5,0,17.3,10.1,17.3,19.6S580,158.5,567.3,158.5L567.3,158.5z M568.8,89.9h-61.2 v148.6h33.9v-50.4h27.4c34.5,0,50-24.1,50-49C618.9,114.5,603.3,89.9,568.8,89.9L568.8,89.9z M720.4,119.5V89.9h-94v148.6h33.9 v-58.4H708v-29.3h-47.7v-31.3H720.4z M728,238.5h33.9V89.9H728V238.5z M802.8,119.5h22.4c13.8,0,20.5,10.6,20.5,20.5 s-6.5,19.6-21.4,19.6h-21.6L802.8,119.5z M843.8,238.5h39.5l-38.4-54.1c23.9-6,34.9-24.4,34.9-45.3c0-24.6-15.5-49.2-50-49.2H769 v148.6h33.9v-52.2h6.7L843.8,238.5z M924.7,209v-28.5h53.9v-30.4h-53.9v-30.6h61.5V89.9h-95.3v148.6h97.3V209H924.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 249.4,
    width: 1025.9,
    height: 76.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014621194720420380620000018079857876180787887_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000014621194720420380620000018079857876180787887_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "c1",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: " M37.8,249.4c0-41.8,33.6-75.9,75.5-75.9c25,0,48.4,12.3,62.5,33l-26.3,18.3c-7.8-11.9-19.2-19.2-34.7-19.2 c-25,0-42.9,19.2-42.9,43.8s17.3,44.4,42.7,44.4c15.8,0,27.2-7.3,34.9-19.4l26.3,18.6c-14.1,20.6-37.6,32.9-62.5,32.8 C71.4,325.8,37.8,291.7,37.8,249.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: " M228,260.2l16.6-52l16.8,52H228z M282.2,324h36l-54.8-148.5h-36.9l-55,148.5h36.2l11-34.5H271L282.2,324z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "m1",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    points: " 502.4,324 484.3,175.5 455.4,175.5 412.7,268.4 369.3,175.5 341,175.5 322.7,324 357.4,324 367.3,239.7 399.6,307 425.5,307  457.9,239.5 467.6,324  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "p1",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: " M567.3,244h-25.9v-39h26.1c12.5,0,17.3,10.1,17.3,19.6S580,244,567.3,244z M568.8,175.4h-61.3V324h33.9v-50.4h27.4 c34.5,0,50-24.1,50-48.9C618.9,200.1,603.3,175.5,568.8,175.4L568.8,175.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "f1",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    points: " 720.5,205 720.5,175.5 626.5,175.5 626.5,324 660.4,324 660.4,265.6 708,265.6 708,236.3 660.3,236.3 660.3,205  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "i1",
    x: 728,
    y: 175.5,
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    width: 33.9,
    height: 148.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "r1",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: " M802.8,205h22.4c13.8,0,20.5,10.6,20.5,20.5s-6.5,19.6-21.4,19.6h-21.6L802.8,205z M843.8,324h39.5l-38.4-54.1 c23.9-6,34.9-24.4,34.9-45.3c0-24.6-15.5-49.2-50-49.2H769V324h33.9v-52.1h6.7L843.8,324z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "e1",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    points: " 924.7,294.5 924.7,266 978.6,266 978.6,235.6 924.7,235.6 924.7,205 986.2,205 986.2,175.5 890.9,175.5 890.9,324 988.2,324  988.2,294.5  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163790419141618076190000002504389000801360282_",
    width: 1025.9,
    height: 79
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011740388644416029410000013220838237424244655_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163790419141618076190000002504389000801360282_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000011740388644416029410000013220838237424244655_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "c2",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: " M37.8,79c0-41.8,33.6-75.9,75.5-75.9c25,0,48.4,12.3,62.5,33l-26.3,18.3c-7.8-11.9-19.2-19.2-34.7-19.2 c-25,0-42.9,19.2-42.9,43.8s17.3,44.4,42.7,44.4c15.8,0,27.2-7.3,34.9-19.4l26.3,18.6c-14.1,20.6-37.6,32.9-62.5,32.8 C71.4,155.4,37.8,121.3,37.8,79z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: " M228,89.8l16.6-52l16.8,52H228z M282.1,153.6h36L263.4,5.1h-36.9l-55,148.6h36.2l11-34.5H271L282.1,153.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "m2",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    points: " 502.4,153.6 484.3,5.1 455.4,5.1 412.6,98 369.3,5.1 341,5.1 322.7,153.7 357.4,153.7 367.3,69.4 399.7,136.7 425.6,136.7  458,69.1 467.7,153.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "p2",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: " M567.3,73.6h-25.9v-39h26.1c12.5,0,17.3,10.1,17.3,19.6S580,73.6,567.3,73.6L567.3,73.6z M568.8,5.1h-61.2v148.6h33.9v-50.5 h27.4c34.5,0,50-24.2,50-48.9S603.3,5.1,568.8,5.1L568.8,5.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "f2",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    points: " 720.5,34.6 720.5,5.1 626.5,5.1 626.5,153.7 660.4,153.7 660.4,95.2 708,95.2 708,65.9 660.3,65.9 660.3,34.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "i2",
    x: 728,
    y: 5.1,
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    width: 33.9,
    height: 148.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "r2",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: " M802.8,34.6h22.4c13.8,0,20.5,10.6,20.5,20.5s-6.5,19.6-21.4,19.6h-21.6L802.8,34.6z M843.8,153.6h39.5l-38.4-54.1 c23.9-6,34.9-24.4,34.9-45.3c0-24.6-15.5-49.2-50-49.2H769v148.6h33.9v-52.2h6.7L843.8,153.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "e2",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    points: " 924.7,124.1 924.7,95.6 978.6,95.6 978.6,65.2 924.7,65.2 924.7,34.6 986.2,34.6 986.2,5.1 890.9,5.1 890.9,153.7 988.2,153.7  988.2,124.1  "
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M492.5,349.6H480v7.3h10v5.3h-10v12.1h-6.1v-30.1h18.6V349.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M495.3,359.3c0-8.6,6.7-15.6,15.3-15.6c8.5,0,15.3,7,15.3,15.6c0,8.5-6.8,15.6-15.3,15.6 C502.1,374.9,495.3,367.8,495.3,359.3z M519.8,359.3c0-5.4-3.8-9.9-9.2-9.9c-5.4,0-9.2,4.5-9.2,9.9s3.8,9.8,9.2,9.8 C516,369.1,519.8,364.7,519.8,359.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M546.7,374.3l-7.2-10.8h-2.1v10.8h-6.1v-30.1h12c6.9,0,9.9,4.9,9.9,9.8c0,4.3-3,8.5-7.3,9.2l7.8,11.1H546.7z  M537.5,349.6v9h4.8c3.4,0,4.8-2.1,4.8-4.5s-1.5-4.6-4.4-4.6h-5.2V349.6z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M242.2,494.4c-0.1-22.2,17.9-40.3,40.1-40.4h0.1c12.8-0.1,24.9,6,32.3,16.4l-12.2,8.9 c-4.4-6.5-11.7-10.4-19.6-10.3c-14.4,0-24.8,11.3-24.8,25.4s10.4,25.6,24.7,25.6c7.9,0.1,15.3-3.8,19.7-10.4l12.2,9 c-7.5,10.4-19.5,16.5-32.3,16.5c-22.3,0-40.3-18.1-40.2-40.4C242.2,494.6,242.2,494.5,242.2,494.4 M371.3,534.1h16.8l-29.4-79.2 h-17.2l-29.6,79.2h17l6.3-19h29.7L371.3,534.1z M340,501.2l10-29.8l10.1,29.8H340z M485.5,534.1l-9.7-79.2H462l-24.3,52l-24.5-52 h-13.6l-9.8,79.2h16.3l5.8-49.1l19.5,40.1H444l19.3-40.1l5.8,49.1H485.5z M553.3,480.7c0-13-7.9-25.9-25.9-25.9H495V534h16v-27.7 h16.3C545.3,506.4,553.3,493.7,553.3,480.7 M537.2,480.7c0,5.6-2.9,11.6-10.6,11.6H511V469h15.8C534.3,469,537.1,475,537.2,480.7  M579.2,534.1h31c22.8,0,36-17,36-39.4s-13.2-39.8-36-39.8h-31V534.1z M595.2,519.9V469h15.1c13.2,0,20,12.1,20,25.6 s-6.8,25.3-20,25.3H595.2z M703.6,534.1h16.8L691,454.9h-17.2l-29.5,79.2h17l6.3-19h29.7L703.6,534.1z M672.2,501.2l10-29.8 l10.1,29.8H672.2z M764.7,454.9L744.8,485l-19.5-30.1h-19.1l30.7,43.2v36h16v-35.8l30.8-43.5L764.7,454.9z M778.2,523.3 c3,0,5.4,2.4,5.4,5.4s-2.4,5.4-5.4,5.4s-5.4-2.4-5.4-5.4S775.2,523.3,778.2,523.3 M778.2,533c2.3,0,4.1-1.9,4.1-4.1v-0.1 c-0.1-2.3-2-4.1-4.2-4c-2.3,0.1-4.1,2-4,4.2C774.1,531.2,775.9,533,778.2,533 M779.4,528.8c0.5,0.2,0.9,0.7,1,1.3 c0.1,0.5,0.2,0.9,0.4,1.3h-1.3c-0.2-0.4-0.4-0.8-0.4-1.3c-0.1-0.6-0.4-0.9-1.1-0.9h-0.6v2.2h-1.2v-5.3c0.7-0.1,1.4-0.2,2.1-0.2 c0.6,0,1.3,0.1,1.9,0.4c0.3,0.3,0.5,0.7,0.5,1.2C780.5,528.2,780,528.7,779.4,528.8L779.4,528.8 M778,528.5c0.7,0,1.2-0.2,1.2-0.8 s-0.3-0.8-1.1-0.8c-0.2,0-0.5,0-0.7,0.1v1.5H778"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.5,401.2c-2.8,6.4-14.6,33.8-15.7,36.3c-0.5,1.1-1.2,1.5-2.5,0.8s-2-1.1-3.1-1.8 c-1.3-0.8-0.9-1.9-0.5-2.7c3.7-7.9,6-13.7,8-18c3.4-7.5,5.1-10.9,6.6-14.1c-5.7,0.6-13.2,1.3-14.9,1.5c-2,0.3-2.2-0.4-2.7-1.6 c-0.4-1-0.3-0.6-0.5-1.2c-0.4-1.1-0.7-2.2,1.3-2.4c4.5-0.5,25.9-2.4,42.3-2.7c1.4,0,1.9,0,2.4,1s0.5,0.9,0.9,2s-0.3,1.5-1.3,1.6 C437,400.3,430.2,400.8,423.5,401.2 M467.5,422.6c0.9-1.6,0.5-2.1-0.5-2.8s-1-0.7-1.6-1.1c-0.9-0.7-2.1-0.5-2.8,0.4l0,0 c-3.9,3.6-7.5,7.5-10.9,11.5c2-5.4,3.1-7.8,3.8-9.5c0.6-1.4,0.5-1.9-0.3-2.4c-0.5-0.4-1.1-0.8-2.1-1.4c-0.6-0.5-1.6-0.4-2.1,0.2 c-2.1,1.9-8.1,7.9-12.1,12.5c2-4.7,3.7-8.8,4.4-10.1s0.7-1.9-0.3-2.6c-0.8-0.6-1.4-1-2.2-1.4c-1.3-0.8-1.8-0.3-2.3,0.6 c-0.2,0.3-0.5,0.8-0.9,1.4c-5.7,9.7-10.3,15-12.2,15.6c-0.8,0.3-1.2,0.1-1.4-0.1c-0.7-0.6-0.1-2.5,0.2-3.2c1-2.7,2.9-6.9,4.8-11 c0.8-1.6,0.5-2-0.5-2.8c-0.7-0.5-1.3-0.9-2.1-1.3c-1.2-0.7-1.9-0.4-2.5,1c-1.6,3.3-5.6,11.7-6.3,16.3c-0.5,3.5,0.9,5,2.9,5.4 c1.4,0.3,2.8,0.1,4.1-0.5c2.1-1,5-3.5,9-9.1c-0.8,2-1.6,4.2-2,5.7c-0.5,1.6-0.2,2,0.8,2.7c0.4,0.3,0.6,0.4,1.3,0.8 c0.7,0.6,1.8,0.5,2.5-0.2l0,0c3.9-4.8,8-9.4,12.3-13.7c-1.1,3-2.8,7.6-3.6,10.5c-0.4,1.3,0,1.7,1,2.4l1.6,1 c0.8,0.5,1.8,0.4,2.3-0.4c0.9-1.1,6.1-7.7,10.3-11.9c-1.3,2.7-2.2,5.6-2.8,8.6c-0.1,0.7-0.6,4.4,3.2,5c1.8,0.3,3.6-0.3,5-1.5 c0.3-0.3,0.6-0.7,0.6-1.2c-0.1-0.4-0.4-0.4-0.8-0.4s-0.8-0.1-1.1-0.3c-1.4-0.7-0.7-2.5-0.4-3.5 C464.6,428.6,465.9,425.5,467.5,422.6 M430.9,412.6c2.1-0.4,3.6-2.3,3.5-4.4c-0.1-1.8-1.6-3.3-3.4-3.3c-0.2,0-0.4,0-0.6,0 c-2.1,0.4-3.6,2.3-3.5,4.4c0.1,1.8,1.6,3.3,3.5,3.2C430.5,412.7,430.7,412.6,430.9,412.6 M621.2,424.3c0.7,1.4,1.3,2.7,1.9,4.2 c0.4,1.2,0.6,2.4,0.4,3.6c-0.5,4-3.2,6.4-7.7,6.4c-2.5,0-4.7-0.6-5.7-2.4c-0.6-0.9-0.5-2.1,0.2-3c0.3-0.4,0.6-0.7,1-1 c0.2-0.2,0.5-0.3,0.8-0.3c0.6,0,0.8,0.3,0.9,1.6c0.2,1.5,1.1,2.4,2.4,2.4c1.1,0,2.1-0.6,2.4-1.7c0.3-1.1,0-2.5-0.9-4.1 c-1-1.7-1.6-3.6-1.6-5.6c-1.1,1.2-2.2,2.6-3.2,4c-4,5.4-6,8.2-9,9.4c-1.3,0.6-2.8,0.7-4.3,0.4c-2.8-0.8-2.9-3.3-2.8-5 c0.5-3,1.5-5.9,2.9-8.6c-4,3.9-7.7,8.1-11.1,12.5c-0.6,0.8-1.6,0.9-2.4,0.4c0,0-0.1,0-0.1-0.1c-0.7-0.5-1-0.6-1.6-1.1 s-1-0.8-0.6-2.2c1.1-4.1,2.6-8,4.3-11.9c-1.7,1.2-3.6,2.1-5.7,2.6c-0.3,1.6-0.9,3.2-1.7,4.6c-3.4,6.1-9.5,9.9-15.5,8.6 c-2.8-0.5-4.8-2.9-4.9-5.8c-1.4,2.1-3.4,3.7-5.6,4.8c-1.4,0.7-3,0.9-4.5,0.6c-3-0.7-3.2-3.2-2.8-5.2c0.1-0.6,0.2-1.2,0.4-1.8 c-3,3.7-5.8,5.8-8.1,6.7c-1.4,0.6-3,0.8-4.5,0.5c-2.1-0.4-3.3-2-3.1-4.8c0.2-3.2,2.5-7.3,7.5-12.9c-0.6-0.3-1.1-0.9-1.3-1.6 c-2.2,2.3-4.8,4.2-7.8,5.5c-0.3,1.9-0.9,3.7-1.8,5.3c-3.3,6-9.7,9.9-15.6,8.3c-5.1-1.4-6.3-7.4-2.8-13.4c1.2-2.1,2.9-3.9,4.8-5.4 l-7.3,0.3c0,0-3.9,8.9-7.5,18.1c-0.2,0.7-0.9,1.2-1.6,1c-0.2,0-0.4-0.2-0.6-0.3c-0.6-0.4-1.3-0.9-1.9-1.4c-0.6-0.4-0.8-1-0.8-1.7 c0-6.2-2.4-11.8-7.5-13.5c-2,4.8-4.2,10.5-6.3,16.1c-0.5,1.2-1.4,1-2.5,0.3c-0.7-0.5-1.1-0.8-1.7-1.3c-0.9-0.8-1.1-1-0.6-2.5 s2.7-7.6,5-13.8l-2.4,0.1c-0.6,0-1-0.1-1.1-0.6c-0.2-0.7-0.4-1.1-0.6-1.6c-0.2-0.7-0.2-1.3,0.9-1.3c0.4,0,2.5-0.1,4.5-0.2 c3.8-9.6,8.7-20.6,9.5-22.4c0.6-1.2,1.6-1.1,2.5-0.6c0.7,0.4,1.6,0.9,2.7,1.6s1.4,1.1,0.7,2.8c-0.1,0.3-4.5,9.4-8.5,18.5 c2.2-0.1,10.2-0.4,12.4-0.4c3.8-9.4,7.8-18.2,8.3-19.5c0.4-0.8,0.7-1.5,2.2-0.8c1.6,0.8,1.9,1,2.9,1.6s1.2,1,0.7,2.2 c-0.3,0.6-3.8,8-7.4,16.3l11.9-0.3c1.7-0.1,3.3,0,4.9,0.2c2,0.5,3.6,2,4.2,4c0.2,0.5,0.3,1,0.4,1.5c3.8-1.9,7-4.9,9.2-8.5 c0.4-0.7,0.8-0.8,1.7-0.4c0.7,0.2,0.5,0.9,0.4,1.3c-0.3,0.9-0.3,1.9,0.1,2.8c0.4,0.7,0.9,1.3,3.7,1.6c0.5,0,0.9,0.3,1.1,0.8 c0.2,0.5,0.2,0.8-0.5,1.6c-3.6,4.1-5.9,6.9-7.1,10.1c-1.5,3.9,0.2,3.8,1,3.6c2.2-0.5,7.3-5.5,10.9-11.7c1.3-3.2,2.8-6.6,4.2-9.7 l-3.4,0.2c-0.5,0.1-1-0.2-1.1-0.7c-0.2-0.4-0.3-0.7-0.5-1.2s-0.2-1,0.9-1.1l5.5-0.4c1.5-3.4,2.8-6.1,3.2-7.1 c0.6-1.3,1.4-1.6,2.6-0.9s1.3,0.8,2.2,1.4s1.3,0.9,0.6,2.4l-1.7,3.7c6.2-0.4,13.2-0.8,17.2-0.9c1.2,0,1.5,0.2,1.7,0.7 s0.5,1,0.7,1.6s0,1.2-0.7,1.2c-8,0.2-15.2,0.5-20.5,0.8c-3,6.5-5.2,11.3-7.8,18.2c-1.4,3.7,0.7,3.1,0.9,3.1 c2.7-0.9,5.5-5.6,8.7-10.4c3.7-5.6,9.2-8.1,13.9-6.9c1.6,0.3,3,1.2,3.9,2.6c0.3,0.4,0.5,0.9,0.7,1.4c0.2,0.7,0.4,1.4,0.4,2.1 c3-0.8,5.7-2.5,7.8-4.8c0.6-0.6,1.2-0.9,2.3-0.1c0.7,0.5,1.2,0.8,1.8,1.3c0.9,0.7,1.3,1.1,0.5,2.7c-1.5,3-2.9,6-4.1,9.2 c3.6-4.5,7.6-8.7,12-12.5c0.6-0.4,1.4-0.4,2,0.1c0.7,0.5,1.1,0.7,1.8,1.2c0.9,0.7,1.2,1.2,0.6,2.5c-1.6,2.9-2.9,6-3.9,9.2 c-0.9,3.1,0.1,3.3,0.9,3.1c1.1-0.3,2.5-1.9,5.7-6c2.5-3.3,5.2-6.5,8.2-9.4c0.8-0.8,2-1.8,2.8-2.4c0.5-0.5,1.1-0.8,1.8-0.9 c0.4,0,0.6,0.1,1,0.5l0.6,0.6c0.5,0.5,0.7,0.7,0.8,1c0,0.6-0.2,0.8-0.9,1.3l-0.3,0.3c-1.4,1.2-3,2.7-1.9,5.1 M500.3,419.4 c-1.5,0-7.3,0.2-10.6,0.3c3.8,1.6,6.5,5.1,7.1,9.1C496.9,428.3,499.1,422.3,500.3,419.4 M524.1,425.6c-2.1,0.1-3.8-1.4-4-3.5 c0-0.4,0-0.9,0.1-1.3c0.2-0.9,0.6-1.7,1.3-2.2h-0.1c-3.1,0.3-5.4,3.6-6.8,6.7c-2.3,4.7-2,9.6,0.9,9.8c2.4,0.1,5.5-2.4,7.5-6.6 C523.3,427.7,523.9,426.3,524.1,425.6 M576.3,425.7c-2.4-0.1-4.4-1.4-3.8-4.6c0.2-0.7,0.5-1.4,1-2c0,0-3.3,0.3-6.6,6.5 c-2.5,4.6-2.1,9.6,1,9.7c2.4,0.1,5.6-2.5,7.5-6.8C575.8,427.6,576.1,426.7,576.3,425.7 M628,436.5c0,1-0.8,1.9-1.8,1.9 c0,0,0,0-0.1,0c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9l0,0C627.1,434.6,627.9,435.4,628,436.5L628,436.5 M627.5,436.5 c0-0.8-0.7-1.4-1.5-1.4s-1.4,0.7-1.4,1.5c0,0.7,0.6,1.3,1.4,1.4C626.8,438,627.4,437.4,627.5,436.5 C627.4,436.6,627.4,436.5,627.5,436.5 M626.8,437c0,0.2,0.1,0.3,0.1,0.5h-0.5c-0.1-0.1-0.1-0.3-0.2-0.5c0-0.2-0.2-0.3-0.4-0.3 h-0.2v0.8h-0.4v-1.9c0.2,0,0.5-0.1,0.7-0.1s0.5,0,0.7,0.1c0.1,0.1,0.2,0.3,0.2,0.4c0,0.2-0.2,0.4-0.4,0.4l0,0 C626.6,436.6,626.7,436.8,626.8,437 M626.3,436.1c0-0.2-0.1-0.3-0.4-0.3h-0.2v0.5h0.2C626.2,436.4,626.3,436.3,626.3,436.1"
  })))), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#c1",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 -100; 0 0; 0 0;",
    keyTimes: "0; 0.25; 0.5; 1",
    keySplines: "0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#a1",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 -100; 0 0; 0 0;",
    keyTimes: "0; 0.03125; 0.28125; 0.53125; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform3 || (_animateTransform3 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#m1",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 -100; 0 0; 0 0;",
    keyTimes: "0; 0.0625; 0.3125; 0.5625; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform4 || (_animateTransform4 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#p1",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 -100; 0 0; 0 0;",
    keyTimes: "0; 0.09375; 0.34375; 0.59375; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform5 || (_animateTransform5 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#f1",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 -100; 0 0; 0 0;",
    keyTimes: "0; 0.125; 0.375; 0.625; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform6 || (_animateTransform6 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#i1",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 -100; 0 0; 0 0;",
    keyTimes: "0; 0.15625; 0.40625; 0.65625; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform7 || (_animateTransform7 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#r1",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 -100; 0 0; 0 0;",
    keyTimes: "0; 0.1875; 0.4375; 0.6875; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform8 || (_animateTransform8 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#e1",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 -100; 0 0; 0 0;",
    keyTimes: "0; 0.21875; 0.46875; 0.71875; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform9 || (_animateTransform9 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#c2",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 100; 0 0; 0 0;",
    keyTimes: "0; 0.25; 0.5; 1",
    keySplines: "0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform10 || (_animateTransform10 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#a2",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 100; 0 0; 0 0;",
    keyTimes: "0; 0.03125; 0.28125; 0.53125; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform11 || (_animateTransform11 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#m2",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 100; 0 0; 0 0;",
    keyTimes: "0; 0.0625; 0.3125; 0.5625; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform12 || (_animateTransform12 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#p2",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 100; 0 0; 0 0;",
    keyTimes: "0; 0.09375; 0.34375; 0.59375; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform13 || (_animateTransform13 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#f2",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 100; 0 0; 0 0;",
    keyTimes: "0; 0.125; 0.375; 0.625; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform14 || (_animateTransform14 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#i2",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 100; 0 0; 0 0;",
    keyTimes: "0; 0.15625; 0.40625; 0.65625; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform15 || (_animateTransform15 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#r2",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 100; 0 0; 0 0;",
    keyTimes: "0; 0.1875; 0.4375; 0.6875; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })), _animateTransform16 || (_animateTransform16 = /*#__PURE__*/React.createElement("animateTransform", {
    xlinkHref: "#e2",
    attributeName: "transform",
    calcMode: "spline",
    dur: "2s",
    type: "translate",
    values: "0 0; 0 0; 0 100; 0 0; 0 0;",
    keyTimes: "0; 0.21875; 0.46875; 0.71875; 1",
    keySplines: "0 0 1 1; 0.5 0 1 0.5; 0 0.5 0.5 1; 0 0 1 1;",
    repeatCount: "indefinite"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfireTitle);
export default __webpack_public_path__ + "static/media/campfire-title.eb08a08deb27f950f013d5a41e269a1a.svg";
export { ForwardRef as ReactComponent };